<script setup lang="ts">
import {CustomNodeProps} from "@/core/interfaces/flowchart/flowchart";

defineProps<{
    node: CustomNodeProps;
}>();

</script>

<template>
  <div>{{ node }}</div>
</template>
